var REPORT_DOM = {
    heightArr: [],
    scrollLocked: false,
    initReportPageHeightList() {
        var dom1 = document.getElementsByClassName('my-report-top-bar')[0];
        var dom2 = document.getElementsByClassName('report-main-content-box')[0];
        var box1 = document.getElementById('characterBox');
        var button1 = document.getElementById('allButtonBox');
        var title1 = document.getElementById('titleBox1');
        var box2 = document.getElementById('wealthBox');
        var title2 = document.getElementById('titleBox2');
        var box3 = document.getElementById('twelveBox');
        var title3 = document.getElementById('titleBox3');
        var box4 = document.getElementById('fiveBox');
        var title4 = document.getElementById('titleBox4');
        var box5 = document.getElementById('lifeLuckBox');
        var title5 = document.getElementById('titleBox5');
        var title6 = document.getElementById('titleBox6');
        let scrollY = 0, hArr = [];
            // 1
            scrollY = dom1 ? dom1.clientHeight+scrollY : scrollY;
            scrollY = dom2 ? dom2.clientHeight+scrollY : scrollY;
            scrollY += 10;
            hArr.push(scrollY);
            // 2
            scrollY = box1 ? box1.clientHeight+scrollY : scrollY;
            scrollY = button1 ? button1.clientHeight+scrollY : scrollY;
            scrollY = title1 ? title1.clientHeight+scrollY : scrollY;
            scrollY -= 88;
            hArr.push(scrollY);
            // 3
            scrollY = box2 ? box2.clientHeight+scrollY : scrollY;
            scrollY = title2 ? title2.clientHeight+scrollY : scrollY;
            scrollY -= 60;
            hArr.push(scrollY);
            // 4
            scrollY = box3 ? box3.clientHeight+scrollY : scrollY;
            scrollY = title3 ? title3.clientHeight+scrollY : scrollY;
            scrollY += 80;
            hArr.push(scrollY);
            // 5
            scrollY = box4 ? box4.clientHeight+scrollY : scrollY;
            scrollY = title4 ? title4.clientHeight+scrollY : scrollY;
            scrollY -= 40;
            hArr.push(scrollY);
            // 6
            scrollY = box5 ? box5.clientHeight+scrollY : scrollY;
            scrollY = title5 ? title5.clientHeight+scrollY : scrollY;
            scrollY = title6 ? title6.clientHeight+scrollY : scrollY;
            scrollY += 248;
            hArr.push(scrollY);
        this.heightArr = hArr;
        // console.log('initReportPageHeightList------', this.heightArr);
    },
    updateReportScrollTopByTab(tabId) {
        var scrollY = 0;
            scrollY = this.heightArr[tabId-1];
        // console.log('scrollY-----', scrollY);
        this.scrollLocked = true;
        setTimeout(() => {
            window.scrollTo({
                left: 0,
                top: scrollY,
                behavior: "smooth",
            });
        }, 20);
        setTimeout(() => {
            this.scrollLocked = false;
        }, 1000);
    },
    bindReportScrollEvent() {
        // console.log('bindReportScrollEvent');
        var scrollList = this.heightArr, lastI = scrollList.length-1;
        window.onscroll = function() {
            var scrollY = document.documentElement.scrollTop || document.body.scrollTop;
            for(var i = 0; i < scrollList.length; i++) {
                if(!REPORT_DOM.scrollLocked && scrollY == 0) {
                    AppFate.$bus.emit('updateReportTab', 0);
                }else if(!REPORT_DOM.scrollLocked && scrollY > scrollList[i] - 10 && scrollY <= scrollList[i+1]) {
                    AppFate.$bus.emit('updateReportTab', i+1);
                }else if(!REPORT_DOM.scrollLocked && i == lastI && scrollY > scrollList[i]) {
                    AppFate.$bus.emit('updateReportTab', i+1);
                }
            }
        }
    }
}
export {
    REPORT_DOM
}